import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth';
import { auth } from './App';
import { setUser, selectUser } from './store/userSlice';

const provider = new GoogleAuthProvider();

const AuthDisplay = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const signIn = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential?.accessToken;
        const user = result.user;
        dispatch(setUser(user));
        //console.log(token, user);
      })
      .catch((error) => {
        console.error("Error during sign in:", error);
        // Handle Errors here.
      });
  };

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        //console.log("Sign out button clicked");

        // const properties = {
        //   distinct_id: user.uid,
        //   email: user.email,
        //   name: user.displayName,
        // };

        //mixpanelTrack("User Signed Out", properties);

      dispatch(setUser(null));

      })
      .catch((error) => {
        // An error happened.
      });
  };

  return (
    <div>
      {!user ? (
        <button onClick={signIn}>Sign In with Google</button>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center'}}>
            <span>Hola, {user.displayName || user.email || 'User'}!</span>
          </div>
          <br />
          <button onClick={handleSignOut}>Sign Out</button>
        </>
      )}
    </div>
  );

};

export default AuthDisplay;
